module.exports = __webpack_public_path__ + "img/Icon-sidebar-heat.c0bff283.svg";